"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpirationWatcher = void 0;
const Constants_1 = require("app/Constants");
const request_1 = require("app/Endpoints/request");
const user_1 = require("app/Endpoints/user");
const Utils_1 = require("app/Utils");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const user_2 = require("app/Redux/Actions/user");
const dialogModal_1 = require("app/Redux/Actions/dialogModal");
function useExpirationWatcher() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleLogout = () => __awaiter(this, void 0, void 0, function* () {
        const result = yield (0, user_1.logoutUser)();
        if (result === request_1.ResponseTypes.OK) {
            dispatch((0, dialogModal_1.setIsLogoutModalOpen)(true));
            dispatch((0, user_2.fetchUserData)());
            (0, Utils_1.deleteCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED);
            localStorage.removeItem(Constants_1.LocalStorage.EXPIRATION_IN_MINUTES);
            localStorage.removeItem(Constants_1.LocalStorage.EXPIRATION_TIME);
        }
    });
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            const expirationTimeStr = localStorage.getItem(Constants_1.LocalStorage.EXPIRATION_TIME);
            const expirationTime = expirationTimeStr ? parseInt(expirationTimeStr, 10) : null;
            if (expirationTime && !isNaN(expirationTime)) {
                const now = Date.now();
                const buffer = 30 * 1000;
                if (expirationTime - buffer <= now) {
                    handleLogout();
                }
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
}
exports.useExpirationWatcher = useExpirationWatcher;
